import { JSX } from 'react';
import { Modal } from '@bg-components/Modal';
import { ModalHeader } from '@bg-components/Modal/ModalHeader';
import { ModalClose } from '@bg-components/Modal/ModalClose';
import { ModalContent } from '@bg-components/Modal/ModalContent';
import { CertifiedBigIcon } from '@bg-components/Icon';
import classNames from 'classnames';
import { fadeAnimation } from '@bg-components/Modals/constants/fadeAnimation';
import { ModalName, IModalProps, t } from '@bg-shared';
import skywardModalClasses from '../styles/SkywardModalsClasses.module.scss';
import classes from './CertifiedRNGModal.module.scss';

export const CertifiedRNGModal = (props: IModalProps): JSX.Element => (
    <Modal
        modalName={ModalName.CERTIFIED_RNG}
        showBackdrop
        className={classNames(skywardModalClasses.modal, classes.modal)}
        onClose={props.onClose}
        animation={fadeAnimation}
    >
        <ModalHeader className={skywardModalClasses.header}>
            {t.string('certified_rng')}
            <ModalClose className={skywardModalClasses.close} onClose={props.onClose} />
        </ModalHeader>
        <ModalContent className={classNames(skywardModalClasses.content, classes.content)}>
            <CertifiedBigIcon className={classes.icon} />
            <div className={classes.section}>
                <h1 className={classes.heading}>{t.string('certified_random_number_generator')}</h1>
                <p className={classes.paragraph}>{t.string('certified_text')}</p>
            </div>
        </ModalContent>
    </Modal>
);
